import { render, staticRenderFns } from "./AsideMenu.vue?vue&type=template&id=2ff6bcdf&"
import script from "./AsideMenu.vue?vue&type=script&lang=ts&"
export * from "./AsideMenu.vue?vue&type=script&lang=ts&"
import style0 from "./AsideMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports